import axios from "../../../../api/axios";

type CheckoutResponse = {
  data: {
    purchaseId: number;
    status: string;
    priceCents: number;
    currency: string;
    credits: number;
    clientSecret: string;
    publishableKey: string;
  };
  message: string;
};

export const checkoutGinoAddon = async (body: { addonId: number }): Promise<CheckoutResponse["data"]> => {
  const response = await axios.post("/gino-tokens/addons/checkout", {
    ...body,
    provider: "stripe",
  });
  return response.data.data;
};
